const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isSurveyDue(storageKey: string): boolean {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return true;
    const last = Number(raw);
    if (!Number.isFinite(last)) return true;
    return Date.now() - last >= WEEK_MS;
  } catch {
    return true;
  }
}

export function markSurveyShown(storageKey: string): void {
  try {
    localStorage.setItem(storageKey, String(Date.now()));
  } catch {
    /* private mode / quota — skip persistence */
  }
}

export const OLD_SITE_EXIT_SURVEY_KEY = 'hatzdaka.oldSiteExitSurveyAt';
export const TASK_SATISFACTION_SURVEY_KEY = 'hatzdaka.taskSatisfactionSurveyAt';

export const TASK_DONE_EVENT = 'hatzdaka-task-done';

export function offerTaskSatisfaction(task: string): void {
  window.dispatchEvent(new CustomEvent(TASK_DONE_EVENT, { detail: { task } }));
}
